export default "__VITE_ASSET__ChZU3sOj__"